/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.workbench.session.desc':
    '会话管理可以查看所有当前仍然有效的会话列表，并且可以强制注销某个会话。注销后，该会话凭证即刻失效，之后的所有操作都需要重新认证。',
  'pages.workbench.session.column.session_id': '会话 ID',
  'pages.workbench.session.column.username': '用户名称',
  'pages.workbench.session.column.ip': '客户端 IP',
  'pages.workbench.session.column.geo_location': '活动地点',
  'pages.workbench.session.column.device_type': '设备类型',
  'pages.workbench.session.column.platform': '操作系统',
  'pages.workbench.session.column.browser': '浏览器',
  'pages.workbench.session.column.login_time': '登录时间',
  'pages.workbench.session.column.last_request': '最后操作时间',
  'pages.workbench.session.column.unknown': '未知',
  'pages.workbench.session.delete': '下线',
  'pages.workbench.session.delete.confirm': '您确定要下线该用户吗？',
  'pages.workbench.session.batch-delete': '批量下线',
  'pages.workbench.session.batch-delete.confirm': '您确定要批量下线选中用户吗？',
};
